export default __webpack_public_path__ + "static/media/scroll_logo.c6afc08f.svg";